import { SiSupabase } from "react-icons/si";

export default function SupabaseIcon({ className }) {
  return <SiSupabase className={className} color="#3ecf8e" />;
}
